import * as React from "react";

export interface RegisterBannerProps { }

export const RegisterBanner = (props: RegisterBannerProps) => {
    return <a href="https://pazintys.draugas.lt/prisijungti.cfm" className="app-register-call-to-action">
        <h2>Registruokis ir gauk<br /><span><b>VIP NARYSTĘ</b></span><br />nemokamai!</h2>
        <div className="button button-large button-red">Registruotis</div>
    </a>;
}